import { UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { CommonService } from 'src/app/core/common.service';
import { invalidCompletedDataCheck, invalidDataCheck } from 'src/app/shared/form/form-validators';

export class CommonFormValidations {

    constructor(public common: CommonService) {

    }

    isDirty(form: UntypedFormArray): boolean {
        return form.dirty;
    }

    isInvalid(form: UntypedFormArray): boolean {
        form.markAllAsTouched();
        return form.invalid;
    }

    isDataInvalid(form: UntypedFormArray): boolean {
        return invalidDataCheck(form);
    }
    isCompletedDataInvalid(form: UntypedFormArray):  { invalid: UntypedFormControl[], ignored: string[] } {
        return invalidCompletedDataCheck(form);
    }

}
